// extracted by mini-css-extract-plugin
export default {"image":"M1ZtgM","content":"fcrlmZ","ribbon":"KaAVRX","listContentText":"jx9wZ9","mobileCardsContentText":"fkgH72","buttonFont":"TUwJIm"};